import { useContext, useEffect, useRef } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import { MyContext } from '../Context/MyProvider';

const PaymentRes = () => {

    const { setPaymentStatus } = useContext(MyContext);

    const location = useLocation();
    const navigate = useNavigate();

    const DataRef = useRef(false);

    useEffect(() => {
        if (DataRef.current) return;
        DataRef.current = true;
        const queryParams = new URLSearchParams(location.search);
        const status = queryParams.get('status');
        const transactionId = queryParams.get('transactionId');
        if (status == "true") {
            setPaymentStatus("PaymentDone");
            if (transactionId) {
                sessionStorage.setItem("transactionid", transactionId);
            }
        } else {
            setPaymentStatus("PaymentFaild");
        }
        navigate("/");
    }, [location.search]);


    return null;
}

export default PaymentRes